import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41723a12")

_pushScopeId("data-v-41723a12")
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-eye" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-plus" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SearchNavBar = _resolveComponent("SearchNavBar")
  const _component_ProductListItem = _resolveComponent("ProductListItem")
  const _component_ListWrapper = _resolveComponent("ListWrapper")
  const _component_ActionButton = _resolveComponent("ActionButton")
  const _component_ActionBar = _resolveComponent("ActionBar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_SearchNavBar, {
      search: _ctx.searchText,
      "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchText = $event)),
      title: "Produtos",
      navigation: "menu",
      "search-placeholder": "Pesquisar por nome..."
    }, null, 8, ["search"]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_ListWrapper, {
        records: _ctx.products,
        loading: _ctx.loading,
        error: _ctx.error,
        "error-msg": "Não foi possível carregar seus produtos.",
        "reload-cb": _ctx.loadProducts,
        "data-test": "productList"
      }, {
        default: _withId((slotProps) => [
          _createVNode(_component_ProductListItem, {
            product: slotProps.record,
            onClick: ($event: any) => (_ctx.handleEdit(slotProps.record.id))
          }, null, 8, ["product", "onClick"])
        ]),
        _: 1
      }, 8, ["records", "loading", "error", "reload-cb"])
    ]),
    _createVNode(_component_ActionBar, null, {
      default: _withId(() => [
        _createVNode(_component_ActionButton, {
          "data-test": "actionViewPrices",
          type: "secondary",
          onClick: _ctx.handleViewPrices
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_ActionButton, {
          "data-test": "actionCreate",
          onClick: _ctx.handleCreate
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    })
  ]))
})